export default __webpack_public_path__ + "static/media/new-user.0001bb48.svg";